import { Component, OnInit } from '@angular/core';
import { Field } from '@ngx-formly/core';

@Component({
  selector: 'tr-static-text',
  templateUrl: './static-text.component.html',
  // styleUrls: ['./static-text.component.scss']
})

export class StaticTextComponent extends Field {

}



// WEBPACK FOOTER //
// ./src/app/stage/components/static-text/static-text.component.ts